import React from 'react'

import Button from 'components/Form/Button'
import CertificateLibrary from 'components/CertificateLibrary'
import { ListSkeleton } from 'components/Skeleton'

import useController from './controller'
import { Header, Page, State, Subtitle, Title } from './styled'

export default function MyCertificates() {
  const { certificates, loading, error, retry } = useController()

  return (
    <Page>
      <Header>
        <div>
          <Title>My Certificates</Title>
          <Subtitle>View and download certificates issued through MagVenture Universe.</Subtitle>
        </div>
      </Header>
      {loading ? (
        <ListSkeleton rows={6} />
      ) : error ? (
        <State>
          <Title>Certificates unavailable</Title>
          <Subtitle>{error}</Subtitle>
          <Button color="blue" nospace width="fit-content" onClick={retry}>Try again</Button>
        </State>
      ) : certificates.length ? (
        <CertificateLibrary certificates={certificates} />
      ) : (
        <State>
          <Title>No certificates yet</Title>
          <Subtitle>Your issued certificates will appear here.</Subtitle>
        </State>
      )}
    </Page>
  )
}
